import * as UseLive from '@webqit/use-live/lite';
import init from './init.js';

init.call( window, UseLive );
